import React from 'react'
import gql from 'graphql-tag'
import ReactPaginate from 'react-paginate'

// import Helmet from './helmet'

const Pagination = ({meta, params: {page}, setParams, paramsPath, canonicalUrl, ...restProps}) => {
	const pageNumber = parseInt(page || 1);
	return (
		<>
			{/*canonicalUrl && (
				Disable currently
				<Helmet>
					{pageNumber < (meta.totalPages || meta.total_pages) && (
						<link rel="next" href={canonicalUrl({page: (pageNumber + 1)})}/>
					)}
					{pageNumber > 1 && (
						<link rel="prev" href={canonicalUrl({page: (pageNumber - 1)})}/>
					)}
				</Helmet>
			)*/}
			<ReactPaginate
				previousLabel="previous"
				nextLabel="next"
				breakLabel={<span>...</span>}
				breakClassName="break-me"
				pageCount={meta.totalPages || meta.total_pages}
				marginPagesDisplayed={2}
				pageRangeDisplayed={5}
				onPageChange={(page) => setParams({page: page.selected === 0 ? null : page.selected + 1})}
				hrefBuilder={paramsPath && ((page) => paramsPath({page: page === 1 ? null : page}))}
				forcePage={pageNumber - 1}
				containerClassName="pagination no-margin"
				subContainerClassName="pages pagination"
				activeClassName="active"
				{...restProps}
			/>
		</>
	)
};

Pagination.fragments = {
	paginationMeta: gql`
		fragment PaginationPaginationMeta on PaginationMeta {
			page
			perPage
			totalPages
			totalCount
			nextPage
			prevPage
		}
	`,
};

export default Pagination;
